import Quill from 'quill';
import useStableCallback from 'src/hooks/useCallbackUtils/useStableCallback';
import { ToolbarAction, ToolbarActionState } from '../../types';
import { toggleActiveState } from '../../utils';
import useActionsState from './useActionsState';
import useImagePicker from './useImagePicker';
import useImg2TxtConverter from './useImg2TxtConverter';
import useKeyboardShortcuts from './useKeyboardShortcuts';
import useLinkActions from './useLinkActions';
import useMathFieldActions from './useMathFieldActions';
import useMFFocused from './useMFFocused';
export default function useToolbar(quill) {
    useKeyboardShortcuts(quill);
    const [actionsState, setActionsState] = useActionsState(quill);
    const [mfFocused] = useMFFocused(quill);
    const mathFieldActions = useMathFieldActions(quill);
    const linkActions = useLinkActions(quill);
    const imagePickerActions = useImagePicker(quill);
    const img2TxtActions = useImg2TxtConverter(quill);
    const handleActionPress = useStableCallback(async (action) => {
        const handlers = {
            [ToolbarAction.BOLD]() {
                const newState = toggleActiveState(actionsState.bold);
                quill?.format('bold', newState, Quill.sources.USER);
                setActionsState(prevState => ({
                    ...prevState,
                    bold: newState,
                }));
            },
            [ToolbarAction.ITALIC]() {
                const newState = toggleActiveState(actionsState.italic);
                quill?.format('italic', newState, Quill.sources.USER);
                setActionsState(prevState => ({
                    ...prevState,
                    italic: newState,
                }));
            },
            [ToolbarAction.UNORDERED_LIST]() {
                const newState = toggleActiveState(actionsState.unorderedList);
                if (newState === ToolbarActionState.ACTIVE) {
                    quill?.format('list', 'bullet', Quill.sources.USER);
                }
                else {
                    quill?.format('list', false, Quill.sources.USER);
                }
                setActionsState(prevState => ({
                    ...prevState,
                    unorderedList: newState,
                    orderedList: ToolbarActionState.INACTIVE,
                }));
            },
            [ToolbarAction.ORDERED_LIST]() {
                const newState = toggleActiveState(actionsState.orderedList);
                if (newState === ToolbarActionState.ACTIVE) {
                    quill?.format('list', 'ordered', Quill.sources.USER);
                }
                else {
                    quill?.format('list', false, Quill.sources.USER);
                }
                setActionsState(prevState => {
                    return {
                        ...prevState,
                        orderedList: newState,
                        unorderedList: ToolbarActionState.INACTIVE,
                    };
                });
            },
            [ToolbarAction.IMAGE]() {
                imagePickerActions.pick();
            },
            [ToolbarAction.HYPERLINK]() {
                linkActions.triggerEdit();
            },
            [ToolbarAction.FORMULA]() {
                mathFieldActions.insert();
            },
            [ToolbarAction.TABLE]() {
                const betterTable = quill?.getModule('better-table');
                betterTable?.insertTable(3, 3);
            },
            [ToolbarAction.IMG2TXT]() {
                img2TxtActions.convert();
            },
            [ToolbarAction.STRIKE_THROUGH]() {
            },
        };
        handlers[action]();
    });
    return [
        { actionsState, mfFocused },
        {
            handleActionPress,
        },
    ];
}
